import { IS_LOCAL } from '@src/constants';
import localBackend from '@src/backend/local';
import defaultBackend from '@src/backend/default';
import { notifications } from '../store/notifications';
import { RequestError } from './types';
import { resetGameState } from '../states/machine/helpers';

function handlePlayError(error: RequestError) {
    if (error.response) {
        // Request made but the server responded with an error
        const { data, status, headers } = error.response;
        console.error(data, status, headers);
        notifications.showError({
            title: error.response.data.message
        });
        resetGameState();
    } else if (error.request) {
        console.log(error.request);

        notifications.showError({
            title: 'Server Error'
        });
    } else {
        console.error('Init request error', error.message);
    }
}

const backend = IS_LOCAL ? localBackend : defaultBackend;
if (IS_LOCAL) {
    console.log('local backend activated');
}

export { backend, handlePlayError };
